import styled, {css, keyframes} from 'styled-components';

export const CHARCOAL = '#C2C2C2';
export const BRIGHT_RED = '#F74747';
export const LIGHT_RED = '#FF8880';
export const YELLOW = '#F6C142';
export const LIGHT_GREEN = '#8DCC93';
export const DARK_GREEN = '#3C9943';
export const LIGHT_BLUE = '#05cfec';
export const BLUE = '#0a8de2';

export const BRIGHT_RED_DARKER = '#CC3B3B';
export const LIGHT_RED_DARKER = '#CC6D66';
export const YELLOW_DARKER = '#CCA237';
export const LIGHT_GREEN_DARKER = '#7DB382';
export const DARK_GREEN_DARKER = '#399642';

export const DARK_GREEN_ALPHA_15 = 'rgba(33,186,69,.15)';
export const YELLOW_ALPHA_15 = 'rgba(251,189,8,.15)';
export const BRIGHT_RED_ALPHA_15 = 'rgba(219,40,40,.15)';
export const DARK_GREEN_ALPHA_30 = 'rgba(33,186,69,.30)';
export const YELLOW_ALPHA_30 = 'rgba(251,189,8,.30)';
export const BRIGHT_RED_ALPHA_30 = 'rgba(219,40,40,.30)';


const BubblesHovering = keyframes`
  0% {
    background-position: -50% calc(100% - -70vw),160% calc(100% - -90vw),top center;
  }
  50% {
    background-position: -50% calc(100% - -90vw),160% calc(100% - -70vw),top center;
  }
  100% {
    background-position: -50% calc(100% - -70vw),160% calc(100% - -90vw),top center;
  }
`;

const ContainerMix = css`
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    overflow: hidden;
    overflow-y: auto;
`;

const CharcoalGradient = `linear-gradient(180deg, ${CHARCOAL} 0%, ${CHARCOAL} 100%)`;

const BrightRedGradient = `linear-gradient(180deg, ${BRIGHT_RED} 0%, ${BRIGHT_RED_DARKER} 100%)`;

const LightRedGradient = `linear-gradient(180deg, ${LIGHT_RED} 0%, ${LIGHT_RED_DARKER} 100%)`;

const YellowGradient = `linear-gradient(180deg, ${YELLOW} 0%, ${YELLOW_DARKER} 100%)`;

const LightGreenGradient = `linear-gradient(180deg, ${LIGHT_GREEN} 0%, ${LIGHT_GREEN_DARKER} 100%)`;

const DarkGreenGradient = `linear-gradient(180deg, ${DARK_GREEN} 0%, ${DARK_GREEN_DARKER} 100%)`;

const BlueGradient = 'linear-gradient(180deg, #0A8EE2 0%, #05CFEC 100%)';

const BubblesMix = css`
    background-repeat: no-repeat, no-repeat, no-repeat;
    background-size: calc(150vw) calc(150vw), calc(150vw) calc(150vw), auto;
    background-position: -50% calc(100% - -100vw),160% calc(100% - -100vw),top center;
    animation: 15s ${BubblesHovering} ease-in-out infinite;
`;

export const FullViewContainer = styled.div`
    width: calc(100vw);
    height: calc(100vh);
`;

export const DefaultContainer = styled.div`${ContainerMix};`;

export const backgroundColorFromTotal = (total, hasLoggedActivityToday) => {
  // no activities logged today, show charcoal
  if (!hasLoggedActivityToday) {
    return CHARCOAL;
  }

  if (total <= -2.5) {
    return BRIGHT_RED;
  } else if (total > -2.5 && total <= -1) {
    return LIGHT_RED;
  } else if (total > -1 && total < 1) {
    return YELLOW;
  } else if (total >= 1 && total < 2.5) {
    return LIGHT_GREEN;
  }

  return DARK_GREEN;
};

const gradientFromTotal = (total, hasLoggedActivityToday) => {
  // no activities logged today, show charcoal
  if (!hasLoggedActivityToday) {
    return CharcoalGradient;
  }

  if (total <= -2.5) {
    return BrightRedGradient;
  } else if (total > -2.5 && total <= -1) {
    return LightRedGradient;
  } else if (total > -1 && total < 1) {
    return YellowGradient;
  } else if (total >= 1 && total < 2.5) {
    return LightGreenGradient;
  }

  return DarkGreenGradient;
};

export const ColoredContainer = styled(DefaultContainer)`
    background-image: url(/images/circle.svg), url(/images/circle.svg), ${props => gradientFromTotal(props.total, props.hasLoggedActivityToday)};
    ${BubblesMix};
`;

export const BlueContainer = styled(DefaultContainer)`
    background-image: url(/images/circle.svg), url(/images/circle.svg), ${BlueGradient};
    ${BubblesMix};
`;

export const CharcoalContainer = styled(DefaultContainer)`
    background-image: url(/images/circle.svg), url(/images/circle.svg), ${CharcoalGradient};
    ${BubblesMix};
`;



// WEBPACK FOOTER //
// ./src/components/Container/ContainerMix.js